import { useEffect, useState } from 'react';
import { Button, Container, Divider, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { Table } from '../../../../../../src/components';
import { request, toast } from '../../../../../../src/utils';
import SearchIcon from '@mui/icons-material/Search';
import { dateFormatter } from '../../../../../../src/utils';





function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

const DETAIL_HEADER = [
    {
        header: 'Patient Name',
        accessor: (row) => `${row.patient.name_suffix} ${row.patient.first_name} ${row.patient.last_name}`
    },
    {
        header: 'UHID No',
        accessor: 'uhid'
    },
    {
        header: 'Adm No.',
        accessor: 'ipd_no'
    },
    {
        header: 'Doctor Name',
        accessor: 'consultant_detail.doctor.name'
    },
    {
        header: 'Sponsor',
        accessor: 'patient.sponsor.name'
    },
    {
        header: 'Ward',
        accessor: 'consultant_detail.room.ward.name'
    },
    {
        header: 'Room No.',
        accessor: 'consultant_detail.room.room_no'
    },
    {
        header: 'Bed',
        accessor: 'consultant_detail.bed_no'
    },
    {
        header: 'Adm Date',
        accessor: (row) => formatDate(row.date)
    },
    {
        header: 'Nur Station',
        accessor: 'consultant_detail.room.nurse_station.name'
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    }
];

const initialIndoorStatusDataObj = {
    data: [],
    loading: false
};

export const ReceptionEnquiry = () => {
    const [detailList, setDetailList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState('');

    const methods = useForm({
        mode: 'all'
    });
    const { handleSubmit, setValue, reset, watch } = methods;

    useEffect(() => {
        searchIPDDetails();
    }, []);

    useEffect(() => {
        handleUhidSearch();
    }, [input, detailList]);

    const searchIPDDetails = async () => {
        setLoading(true);
        try {
            const response = await request('/indoor-registeration-status', {
                method: 'GET'
            });
            if (response?.success) {
                if (!response?.data || response.data.length === 0) {
                    toast('No IPD found', { variant: 'warning' });
                } else {
                    const filteredData = response.data.filter(item => item.admission_status === 'admit');
                    const sortedData = filteredData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                    setDetailList(sortedData);
                }
            } else {
                toast('Failed to load patient details', { variant: 'error' });
            }
        } catch (error) {
            toast('Error fetching patient details', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleUhidSearch = () => {
        const lowercasedInput = input.toLowerCase();
        const filtered = detailList.filter((item) =>
            item.ipd_no.toString().toLowerCase().includes(lowercasedInput) ||
            item.patient.first_name.toLowerCase().includes(lowercasedInput)
        );
        setFilteredData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
    };

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: '100vw',
                        boxSizing: 'border-box',
                        minWidth: "100%"
                    }}
                >
                    <FormProvider methods={methods}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Reception Enquiry
                            </Typography>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
                                >
                                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                                        <MuiTextField
                                            sx={{
                                                width: '100%',
                                                padding: 0,
                                                '& .MuiInputBase-input': {
                                                    fontSize: '1.4rem', // Adjust the font size as needed
                                                },
                                            }}
                                            label="Search Patient"
                                            variant="outlined"
                                            value={input}
                                            onChange={handleChange}
                                        />
                                    </Stack>
                                    <Table
                                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                        data={filteredData}
                                        columns={DETAIL_HEADER}
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container>
            </Paper>
        </>
    );
};
